var React = require('react');

function Email (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"16","cy":"16","r":"16","fill":"#800DF2","key":0}),React.createElement("path",{"d":"M22.6667 9.33334H9.33334C8.41417 9.33334 7.66667 10.0808 7.66667 11V21C7.66667 21.9192 8.41417 22.6667 9.33334 22.6667H22.6667C23.5858 22.6667 24.3333 21.9192 24.3333 21V11C24.3333 10.0808 23.5858 9.33334 22.6667 9.33334ZM22.6667 11V11.4258L16 16.6117L9.33334 11.4267V11H22.6667ZM9.33334 21V13.5367L15.4883 18.3242C15.6343 18.4388 15.8144 18.5011 16 18.5011C16.1856 18.5011 16.3657 18.4388 16.5117 18.3242L22.6667 13.5367L22.6683 21H9.33334Z","fill":"white","key":1})]);
}

Email.defaultProps = {"width":"44","height":"44","viewBox":"0 0 32 32","fill":"none"};

module.exports = Email;

Email.default = Email;
